export default __webpack_public_path__ + "static/tasa-nominal-sm-9b19fd3c8dc0c833158aa5c5e772acc0.png";